import { PASSWORD_ALPHABET, PASSWORD_LENGTH } from './constants.ts';

// One generator for every generated password: the secrets script, and the
// "Generate" button when an admin creates an account or sets a password.
// WebCrypto only, so it runs in Node 24, workerd, and the browser alike.

const BYTE_VALUES = 256;

/** PASSWORD_LENGTH symbols drawn uniformly from PASSWORD_ALPHABET. */
export function randomPassword(): string {
  const symbols = PASSWORD_ALPHABET.length;
  // Rejection sampling: bytes at or above the largest multiple of the
  // alphabet size are thrown away, so no symbol is likelier than another.
  const limit = Math.floor(BYTE_VALUES / symbols) * symbols;
  let password = '';
  while (password.length < PASSWORD_LENGTH) {
    const bytes = crypto.getRandomValues(new Uint8Array(PASSWORD_LENGTH));
    for (const byte of bytes) {
      if (byte < limit && password.length < PASSWORD_LENGTH) {
        password += PASSWORD_ALPHABET[byte % symbols] ?? '';
      }
    }
  }
  return password;
}
